/**
 * DR Vitamin — cart page + drawer interactions (owner P0 2026-09-15, cart / pre-checkout UX).
 * Markup: snippets/drv-cart-body.liquid inside [data-drv-cx] (data-ctx="page" on /cart, "drawer" in the minicart).
 *
 *   quantity +/−/typed   POST /cart/change.js {id: line key, quantity}
 *   remove               POST /cart/change.js {id, quantity: 0}
 *   «قد يعجبك» quick add POST /cart/add.js {items: [{id, quantity: 1}]} — the button exists only for in-stock single-variant products
 *   order note           POST /cart/update.js {note}; Save / Cancel
 * Every call asks Shopify for the re-rendered markup in the same request (Section Rendering API): the page swaps its own
 * section in place (scroll position kept, no reload, no drawer popping open on the cart page); the drawer hands the minicart
 * section to the theme's own `drawer:Minicart` event, which also refreshes the header counters.
 * Requests run one at a time, so fast taps cannot race each other. Coupon + resume-checkout stay in assets/drv-cart.js.
 *
 * Sticky checkout (page, below 990px): a compact total + «إتمام الطلب» bar appears only while the real checkout button is below
 * the fold, disappears as soon as the totals are on screen, and never shows while the customer is typing (keyboard up).
 */
(function () {
  if (window.__drvCartUi) return; window.__drvCartUi = true;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var queue = Promise.resolve();
  function post(path, body) {
    return fetch(root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) { var e = new Error(j.description || j.message || ('HTTP ' + r.status)); e.status = r.status; throw e; } return j; }); });
  }
  function box(el) { return el.closest('[data-drv-cx]'); }
  function sectionsFor(cx) { return cx.dataset.ctx === 'page' ? cx.dataset.sectionId : 'minicart'; }
  function setCount(n) {
    document.querySelectorAll('.js-cart-count').forEach(function (e) { e.textContent = n; e.setAttribute('data-js-cart-count', n); });
  }
  function render(cx, json, focusKey) {
    var html = json && json.sections && json.sections[sectionsFor(cx)];
    if (cx.dataset.ctx === 'drawer') {
      if (html) document.body.dispatchEvent(new CustomEvent('drawer:Minicart', { detail: { response: json } }));
      return;
    }
    var id = cx.dataset.sectionId, host = document.getElementById('shopify-section-' + id);
    if (!html || !host) { window.location.reload(); return; }
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-' + id) || doc.querySelector('.shopify-section');
    if (!fresh) { window.location.reload(); return; }
    var y = window.scrollY;
    host.innerHTML = fresh.innerHTML;
    window.scrollTo(0, y);
    var nx = host.querySelector('[data-drv-cx]');
    if (focusKey && nx) {
      var li = nx.querySelector('[data-drv-cart-item][data-key="' + CSS.escape(focusKey) + '"] [data-drv-cx-qty]');
      if (li) li.focus({ preventScroll: true });
    }
    bar();
    document.body.dispatchEvent(new Event('contentUpdated'));
  }
  function refreshCount() { fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); }).catch(function () {}); }
  function run(el, fn) {
    var cx = box(el); if (!cx) return;
    var busyEl = el.closest('[data-drv-cart-item], .drv-cx-rec, [data-drv-cx-note]') || cx;
    busyEl.classList.add('is-busy');
    queue = queue.then(function () { return fn(cx); }).catch(function (err) {
      busyEl.classList.remove('is-busy');
      var msg = busyEl.querySelector('[data-drv-cx-msg], [data-drv-cx-note-msg]');
      var body = cx.querySelector('[data-drv-cart-extras]');
      if (msg) { msg.textContent = (err && err.status === 422 && err.message) || (body && body.dataset.msgQty) || ''; msg.className = msg.className.replace(/ is-\w+/g, '') + ' is-error'; }
    });
  }
  function changeLine(el, qty) {
    var li = el.closest('[data-drv-cart-item]'); if (!li) return;
    var key = li.dataset.key;
    run(el, function (cx) {
      return post('cart/change.js', { id: key, quantity: qty, sections: sectionsFor(cx), sections_url: window.location.pathname })
        .then(function (json) { setCount(json.item_count); render(cx, json, qty > 0 ? key : null); });
    });
  }

  document.addEventListener('click', function (e) {
    var t;
    if ((t = e.target.closest('[data-drv-cx-step]'))) {
      e.preventDefault();
      var li = t.closest('[data-drv-cart-item]'); var cur = +(li && li.dataset.qty) || 1;
      var next = Math.max(1, cur + (+t.getAttribute('data-drv-cx-step')));
      if (next !== cur) changeLine(t, next);
      return;
    }
    if ((t = e.target.closest('[data-drv-cx-remove]'))) { e.preventDefault(); changeLine(t, 0); return; }
    if ((t = e.target.closest('[data-drv-cx-add]'))) {
      e.preventDefault(); if (t.disabled) return;
      var vid = +t.getAttribute('data-drv-cx-add');
      run(t, function (cx) {
        return post('cart/add.js', { items: [{ id: vid, quantity: 1 }], sections: sectionsFor(cx), sections_url: window.location.pathname })
          .then(function (json) { refreshCount(); render(cx, json); });
      });
      return;
    }
    if ((t = e.target.closest('[data-drv-cx-note-save]'))) {
      e.preventDefault();
      var nd = t.closest('[data-drv-cx-note]'); var ta = nd.querySelector('[data-drv-cx-note-input]');
      var val = ta.value.trim();
      run(t, function (cx) {
        return post('cart/update.js', { note: val }).then(function () {
          nd.classList.remove('is-busy');
          ta.value = val; ta.setAttribute('data-saved', val);
          var m = nd.querySelector('[data-drv-cx-note-msg]'); var body = cx.querySelector('[data-drv-cart-extras]');
          if (m) { m.textContent = body ? body.dataset.msgNoteSaved : ''; m.className = 'drv-cx-note__msg is-ok'; }
        });
      });
      return;
    }
    if ((t = e.target.closest('[data-drv-cx-note-cancel]'))) {
      e.preventDefault();
      var n2 = t.closest('[data-drv-cx-note]'); var ta2 = n2.querySelector('[data-drv-cx-note-input]');
      ta2.value = ta2.getAttribute('data-saved') || ''; n2.open = false;
      var m2 = n2.querySelector('[data-drv-cx-note-msg]'); if (m2) m2.textContent = '';
    }
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest && e.target.closest('[data-drv-cx-qty]'); if (!input) return;
    var li = input.closest('[data-drv-cart-item]'); var cur = +(li && li.dataset.qty) || 1;
    var next = Math.max(1, Math.floor(+input.value || 1));
    input.value = next;
    if (next !== cur) changeLine(input, next);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches('[data-drv-cx-qty]')) { e.preventDefault(); e.target.blur(); }
  });

  /* ---- sticky mobile checkout bar (page only) ---- */
  var ticking = false;
  function bar() {
    var cx = document.querySelector('[data-drv-cx][data-ctx="page"]'); if (!cx) return;
    var b = cx.querySelector('[data-drv-cx-bar]'), cta = cx.querySelector('[data-drv-cx-checkout]'), totals = cx.querySelector('[data-drv-totals]');
    if (!b || !cta) return;
    var typing = document.activeElement && cx.contains(document.activeElement) && /^(INPUT|TEXTAREA)$/.test(document.activeElement.tagName) && document.activeElement.type !== 'button';
    var below = (totals || cta).getBoundingClientRect().top > window.innerHeight - 4;
    var on = window.innerWidth < 990 && below && !typing;
    if (b.classList.contains('is-on') !== on) {
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-hidden', on ? 'false' : 'true');
      var btn = b.querySelector('button'); if (btn) btn.tabIndex = on ? 0 : -1;
      document.body.classList.toggle('drv-cxbar-on', on);
    }
  }
  function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { ticking = false; bar(); }); }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  document.addEventListener('focusin', onScroll); document.addEventListener('focusout', function () { setTimeout(bar, 50); });
  document.addEventListener('toggle', onScroll, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bar); else bar();
})();
